import { RefObject, useEffect } from 'react';

interface UseClickOutsideProps {
  ref: RefObject<HTMLElement>;
  onClose: () => void;
  enabled?: boolean;
}

export const useClickOutside = ({ ref, onClose, enabled = true }: UseClickOutsideProps) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (!enabled) {
      return undefined;
    }

    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [ref, onClose, enabled]);
};
